<template>
  <div class="orderhall">
    <div class="warp2">
      <!-- <h3>抢单大厅</h3> -->
      <div class="title_search">
        <el-form
          :show-overflow-tooltip="true"
          :inline="true"
          :model="formInline"
          class="title_search_form"
          size="mini"
        >
          <el-form-item class="type_text" :inline="true" label="商品名称:">
            <el-input v-model="goodsName" placeholder="商品名称"></el-input>
          </el-form-item>

          <el-form-item class="type_text" label="出口国家/地区:">
            <el-input
              v-model="receiveCountry"
              placeholder="出口国家/地区"
            ></el-input>
          </el-form-item>

          <div class="title_search_time">
            <el-form-item label="发布时间:" size="mini" class="type_time">
              <el-date-picker
                style="width: 210px"
                v-model="search_time"
                type="daterange"
                unlink-panels
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              >
              </el-date-picker>
            </el-form-item>
          </div>

          <el-form-item label="状态" class="type_selit">
            <el-select v-model="state" placeholder="订单状态">
              <el-option
                v-for="item in stateList"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="onSearchHistory(1)"
              class="title_subit"
              >搜索</el-button
            >
            <el-button type="primary" @click="onReset" class="title_Reset"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <!-- 下方结构表头 -->
      <div class="order_title_info flex_row_start_center list_title">
        <div class="select_name" style="width:515px; font-weight: 700;">
          商品信息
        </div>
        <div class="good_price" style="width: 120px;font-weight: 700; ">
          价格（美元）
        </div>
        <div class="num" style="width: 100px;font-weight: 700 ">数量</div>
        <div class="num" style="width: 158px;font-weight: 700 ">
          出口国家/地区
        </div>
        <div class="state" style="width: 130px;font-weight: 700">发布时间</div>
        <div class="oprate" style="width: 110px;font-weight: 700">状态</div>
        <div class="oprate" style="font-weight: 700; margin-right: 10px">
          操作
        </div>
      </div>
      <!-- 下方结构表格 -->
      <block v-if="order_list.length > 0">
        <div
          class="order_item"
          v-for="(item, index) in order_list"
          :key="index"
        >
          <!-- 商品信息 -->
          <!-- 图片 -->
          <div class="order_gg goods_info">
            <div v-for="(it, idx) in item.goodsImage" :key="idx">
              <el-image
                class="imgesss"
                :src="it"
                :preview-src-list="item.goodsImage"
                :initial-index="0"
                fit="cover"
              />
            </div>
            <div class="goods_info_item">
              <span :title="item.goodsName">{{ item.goodsName }} </span>
              <span :title="item.goodsSpec">{{ item.goodsSpec }}</span>
            </div>
          </div>
          <!-- 价格 -->
          <div class="order_gg fboprice">
            {{ item.fboprice === 0 ? '*' : item.fboprice }}
            <!-- {{ item.fboprice}} -->
          </div>
          <!--数量  -->
          <div class="order_gg number">
            <div class="jus">
              <text>{{ item.number }}</text>
            </div>
          </div>
          <!--出口国  -->
          <div class="order_gg country">
            <div class="jus">
              <text>{{ item.receiveCountry }}</text>
            </div>
          </div>
          <!--时间 -->
          <div class="order_gg time">{{ item.createTime }}</div>

          <!--状态  -->
          <div class="order_gg statess">{{ item.inquiryState }}</div>
          <!-- 操作 -->
          <div class="do">
            <div class="order_gg">
              <a
                href="https://seller.heronlink.net/base/#/order/order_grab"
                target="_blank"
                >回复</a
              >
            </div>
          </div>
        </div>

        <el-pagination
          @prev-click="handlePrevCilickChange"
          @size-change="handleSizeChange"
          @next-click="handleNextCilickChange"
          @current-change="handleCurrentChange"
          :current-page="pageData.current"
          :page-sizes="[1, 2, 4, 6, 8]"
          :page-size="pageData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.total"
          class="flex_row_end_center"
        >
        </el-pagination>
      </block>

      <block v-else>
        <SldCommonEmpty :tip="'暂无订单～'" totalWidth="74px"
      /></block>
    </div>
  </div>
</template>

<script>
import { ref, getCurrentInstance, onMounted, reactive } from 'vue'
import { ElMessage } from 'element-plus'
import SldCommonEmpty from '../../components/SldCommonEmpty.vue'
export default {
  name: 'orderhall',
  components: {
    SldCommonEmpty
  },
  setup () {
    const { proxy } = getCurrentInstance()
    const stateList = ref([
      {
        value: '1',
        label: '询价中'
      },
      {
        value: '2',
        label: '已完成'
      }
    ]) //状态数组
    const L = proxy.$getCurLanguage()
    const search_time = ref('') //搜索栏选择的时间
    const goodsName = ref('') //商品名称
    const receiveCountry = ref('') //目的国
    const state = ref('') //询价单状态
    const order_list = ref([]) //订单列表
    // const goodsImageList = ref([]) //图片列表，预览用
    const pageData = reactive({
      current: 1,
      pageSize: 8,
      total: 0
    })
    //获取订单列表
    const getOrderList = () => {
      let param = {}
      param.pageSize = 8
      proxy
        .$get('/v3/business/front/orderInfo/getInquiryHall', param)
        .then(res => {
          console.log('getOrderList', res)
          if (res.state == 200) {
            order_list.value = res.data.list
            // // goodsImageList.value = res.data.list.map(item => {
            // //   return item.goodsImage
            // // })
            // res.data.list.forEach(item => {
            //   goodsImageList.value.push(item.goodsImage)
            // })
            pageData.total = res.data.pagination.total
          } else {
            ElMessage(res.msg)
          }
        })
    }

    //组件时间处理
    const playTime = time => {
      var date = new Date(time)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? '0' + d : d
      let times = y + '-' + m + '-' + d //这里如果不需要小时 分  后边的可以不需要拼接
      return times
    }
    //     搜索点击事件
    const onSubmit = () => {
      let param = {}
      param.current = pageData.current
      param.pageSize = pageData.pageSize
      if (search_time.value) {
        let startTime = playTime(search_time.value[0])
        let endTime = playTime(search_time.value[1])
        if (startTime) {
          param.startTime = startTime
        }
        if (endTime) {
          param.endTime = endTime
        }
      }
      if (goodsName.value) {
        param.goodsName = goodsName.value
      }
      if (receiveCountry.value) {
        param.receiveCountry = receiveCountry.value
      }
      if (state.value) {
        param.state = state.value
      }

      proxy
        .$get('/v3/business/front/orderInfo/getInquiryHall', param)
        .then(res => {
          if (res.state == 200) {
            order_list.value = res.data.list
            pageData.total = res.data.pagination.total
          } else {
            ElMessage(res.msg)
          }
        })
    }

    //点击条每页事件事件
    const handleSizeChange = index => {
      pageData.pageSize = index
      onSubmit()
    }
    //向前翻页
    const handlePrevCilickChange = e => {
      pageData.current = e
      onSubmit()
    }
    //向后翻页
    const handleNextCilickChange = () => {
      pageData.current++
      onSubmit()
    }
    //页数改变
    const handleCurrentChange = current => {
      pageData.current = current
      onSubmit()
    }
    /* 询价记录搜索事件 */
    const onSearchHistory = current => {
      pageData.current = current
      onSubmit()
    }
    //点击重置按钮事件
    const onReset = () => {
      //       console.log(contactName, contactPhone, state);
      goodsName.value = ''
      receiveCountry.value = ''
      state.value = ''
      search_time.value = ''
      onSubmit()
    }

    onMounted(() => {
      getOrderList()
    })
    return {
      L,
      goodsName,
      receiveCountry,
      search_time,
      stateList,
      order_list,
      pageData,
      state,
      // goodsImageList,
      getOrderList,
      handleSizeChange,
      handlePrevCilickChange,
      handleNextCilickChange,
      handleCurrentChange,
      onSearchHistory,
      onReset
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/orderhall.scss';
</style>
